import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api'

export const USERS_LOAD_START = 'USERS_LOAD_START'
export const USERS_LOAD_SUCCESS = 'USERS_LOAD_SUCCESS'
export const USERS_LOAD_ERROR = 'USERS_LOAD_ERROR'

export const USERS_ACTIVE_LOAD_START = 'USERS_ACTIVE_LOAD_START'
export const USERS_ACTIVE_LOAD_SUCCESS = 'USERS_ACTIVE_LOAD_SUCCESS'
export const USERS_ACTIVE_LOAD_ERROR = 'USERS_ACTIVE_LOAD_ERROR'

export const USER_ADD_START = 'USER_ADD_START'
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS'
export const USER_ADD_ERROR = 'USER_ADD_ERROR'

export const USER_LOAD_START = 'USER_LOAD_START'
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS'
export const USER_LOAD_ERROR = 'USER_LOAD_ERROR'

export const USER_UPDATE_START = 'USER_UPDATE_START'
export const USER_UPDATE_SUCESS = 'USER_UPDATE_SUCESS'
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR'

export const USER_DELETE_START = 'USER_DELETE_START'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR'

export const CLEAR_USERS = 'CLEAR_USERS'
export const CLEAR_USER = 'CLEAR_USER'

export const loadUsers = (query) => ({ getState, fetch }) => ({
  type: 'USERS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'users',
    getState,
    query,
  }),
})

export const loadActiveUsers = (query) => ({ getState, fetch }) => ({
  type: 'USERS_ACTIVE_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'users/on',
    getState,
    query,
  }),
})

export const loadUser = (id) => ({ getState, fetch }) => ({
  type: 'USER_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `users/${id}`,
    getState,
  }),
})

export const createUser = (body) => ({ getState, fetch }) => ({
  type: 'USER_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'users',
    getState,
    body,
  }),
})

export const updateUser = (body) => ({ getState, fetch }) => ({
  type: 'USER_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `users/${body._id}`,
    getState,
    body,
  }),
})

export const deleteUser = (id) => ({ getState, fetch }) => ({
  type: 'USER_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `users/${id}`,
    getState,
  }),
})

export const clearUsers = () => ({
  type: 'CLEAR_USERS',
  payload: {},
})

export const clearUser = () => ({
  type: 'CLEAR_USER',
  payload: {},
})

export const getUsersCSV = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_USERS_CSV',
  payload: apiGet({
    fetch,
    endpoint: 'users/csv',
    getState,
    query,
  }),
})



// WEBPACK FOOTER //
// ./src/common/users/actions.js